var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tt-closed-slot",style:(`left: ${_vm.left}px; width: ${_vm.width}; height: ${_vm.height}px`)},[_vm._v("   ")])
}
var staticRenderFns = []

export { render, staticRenderFns }